import DialogActions from '@mui/material/DialogActions'
import styled from 'styled-components'

export const PasswordControls = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 8px;
`

export const EmailWarning = styled.aside`
  padding: 12px;
  color: #9a6700;
  background-color: #fff8c5;
  border-radius: 4px;
`

export const PasswordCopySection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
`

export const PasswordValue = styled.code`
  overflow-wrap: anywhere;
  font-size: 16px;
`

export const StyledDialogActions = styled(DialogActions)`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px 24px !important;
`
